import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { TenantCredentialListMaintenanceDto } from './TenantCredentialListMaintenanceDto';
import { TenantCredentialItemMaintenanceDto } from './TenantCredentialItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { Observable } from 'rxjs';

@Injectable()
export class TenantCredentialMaintenanceController extends BaseMaintenanceController<TenantCredentialListMaintenanceDto, TenantCredentialItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "tenantcredential");
    }

    public getResourceRoot(): string {
        return "TENANTCREDENTIAL";
    }

    public buildUrl(uri: string): string {
        return "/system/tenantcredential" + uri;
    }



    public getAzureLoginParameters(key: string): Observable<string[]> {
        return this.get("/maintenance/tenantcredential/azureparameters/" + key);
    }

    public checkUrlSsoExists(key: string): Observable<boolean> {
        return this.get("/maintenance/tenantcredential/urlexist/" + key);
    }
} 